import styled from 'styled-components';

export const StyledTextarea = styled.textarea`
  width: 100%;
  padding: 0.7rem 0.9rem;
  box-sizing: border-box;
  background-color: ${Styles.color.white};
  border: 1px solid rgb(220, 220, 220);
  border-radius: 4px;
  resize: none;
`;
